/*
 * <carousel-element data-section-id="{{ section.id }}"></carousel-element>
 */

class CarouselElement extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    let shouldAutoplay = this.dataset.autoplay === "true" && !Shopify.designMode;
    this.sectionId = this.getAttribute("data-section-id");
    this.swiperEl = this.querySelector("swiper-container");
    this.autoplayParams = {
      pauseOnMouseEnter: true,
      delay: parseInt(this.dataset.autoplayDelay),
    };
    this.swiperParams = {
      loop: true,
      autoplay: shouldAutoplay ? this.autoplayParams : false,
      simulateTouch: false,
      navigation: {
        prevEl: `#shopify-section-${this.sectionId} button[data-direction='prev']`,
        nextEl: `#shopify-section-${this.sectionId} button[data-direction='next']`,
      },
      pagination: {
        type: "fraction",
        el: `#shopify-section-${this.sectionId} [data-pagination]`,
        renderFraction: (currentClass, totalClass) =>
          `<span class="${currentClass}"></span><span class="swiper-pagination-progress"><span class="swiper-pagination-progress-inner" data-progress></span></span><span class="${totalClass}"></span>`,
      },
      on: {
        init: () => this.onSwiperInit(),
        autoplayPause: () => this.stopProgressIndicator(),
        autoplayResume: () => this.resumeProgressIndicator(),
        activeIndexChange: () => this.restartProgressIndicator(),
      },
    };
    Object.assign(this.swiperEl, this.swiperParams);
    this.swiperEl.initialize();
    if (Shopify.designMode && this.swiperEl) {
      document.addEventListener("shopify:block:select", this.onBlockSelect.bind(this));
    }
  }

  onSwiperInit() {
    this.setAttribute("data-swiper-initialized", "true");
  }

  stopProgressIndicator() {
    const progressIndicator = this.querySelector("[data-progress]");
    const animations = progressIndicator.getAnimations();
    animations.forEach((animation) => {
      animation.pause();
    });
  }

  resumeProgressIndicator() {
    const progressIndicator = this.querySelector("[data-progress]");
    const animations = progressIndicator.getAnimations();
    animations.forEach((animation) => {
      animation.play();
    });
  }

  restartProgressIndicator() {
    const progressIndicator = this.querySelector("[data-progress]");
    if (!progressIndicator) return;
    const animations = progressIndicator.getAnimations();
    animations.forEach((animation) => {
      animation.cancel();
      animation.play();
    });
  }

  onBlockSelect(event) {
    if (event.detail.sectionId !== this.sectionId) return;
    const targetSlide = this.querySelector(`#slide-${event.detail.blockId}`);
    const targetIndex = parseInt(targetSlide.getAttribute("data-swiper-slide-index"));
    this.swiperEl.swiper.slideTo(targetIndex, 0);
    document.addEventListener("shopify:block:deselect", this.onBlockDeselect.bind(this), { once: true });
  }

  onBlockDeselect(event) {
    if (event.detail.sectionId !== this.sectionId) return;
    this.swiperEl.swiper.slideTo(0, 0);
  }
}

customElements.define("carousel-element", CarouselElement);
